import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-dialog-modal',
  templateUrl: './dialog-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './dialog-modal.component.scss'
})
export class DialogModalComponent {
  @Input() isVisible: boolean = false;
  @Input() size:string='medimum';
  @Input() popLoader:boolean = false;
  modalSize:any;

  ngOnInit(){
      this.makeSize();
  }

  ngAfterContentChecked(){
      
     this.makeSize();
  }

  makeSize(){
       switch(this.size){
       case "medimum":
        this.modalSize="";
        break;
       case "large":
        this.modalSize="modal-lg";
        break;
      case "extra-large":
        this.modalSize="modal-xl";
         break;
      case "full-screen":
        this.modalSize="full-screen";
        break;
      default:
       this.modalSize="";
       break;
     }
  }

}
